/* global globalThis */
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useHistory, useLocation } from "react-router-dom";
import { useStyles } from "examsbook-react-sdk/custom-hooks";
import pathToRegexp from "path-to-regexp";
import "../Profile/profile.scss";
import { Box } from '@material-ui/core';

const capitalize = (str) => str.charAt(0).toUpperCase() + str.slice(1);

const VALID_PATHS = new Set(["/dashboard", "/certificate-list"]);

const HANDLED_PATHS = new Set([
  "/support",
  "/surveys",
  "/my-courses",
  "/courses",
  "/notifications",
  "/reports/:slug/:id",
  "/course/:id",
  "/course/leaderboard/:id",
  "/support-ticket",
]);

/**
 * Navigation
 * @returns {*}
 * @constructor
 */
const Navigation = ({
  children,
  openSidebar,
  windowScreenWidth,
  screenWidth,
  closeDrawer,
}) => {
  const history = useHistory();
  const location = useLocation();
  const isFirefox = globalThis.navigator?.userAgent?.toLowerCase().includes("firefox");
  const currentPath = location.pathname;

  useEffect(() => {
    // To start listening for location changes...
    let unListen = history.listen((obj) => {
      if (globalThis.ReactNativeWebView?.postMessage) {
        globalThis.ReactNativeWebView.postMessage(obj.pathname);
      }
    });
    return () => {
      return unListen();
    };
  }, [history]);

  useEffect(() => {
    if (isFirefox) {
      if (
        VALID_PATHS.has(currentPath)) {
        const mainDivs = document.querySelectorAll(".firefox-browser");
        mainDivs.forEach((mainDiv) => {
          mainDiv.style.height = "100vh";
          mainDiv.style.paddingBottom = "80px";
        });
      } else if (HANDLED_PATHS.has(currentPath)) {
        const mainDivs = document.querySelectorAll(".firefox-browser");
        mainDivs.forEach((mainDiv) => {
          mainDiv.style.height = "100vh";
        });
      } else {
        const mainDivs = document.querySelectorAll(".firefox-browser");
        mainDivs.forEach((mainDiv) => {
          mainDiv.style.paddingBottom = "0px";
        });
      }
    }
  }, [isFirefox, currentPath]);

  useEffect(() => {
    let title = "";
    if (pathToRegexp("/quiz/:mode/:slug/:id").exec(location.pathname)) {
      const name = capitalize(
        pathToRegexp("/quiz/:mode/:slug/:id")
          .exec(location.pathname)[2]
          .replaceAll("-", " ")
      );
      title = `${name} | LMS`;
    } else if (pathToRegexp("/course/:id").exec(location.pathname)) {
      title = "Self Learning | LMS";
    } else if (pathToRegexp("/course/leaderboard/:id").exec(location.pathname)) {
      title = "Leaderboard | LMS";
    } else if (pathToRegexp("/reports/:slug/:id").exec(location.pathname)) {
      title = "Reports | LMS";
    } else {
      switch (location.pathname) {
        case "/dashboard":
          title = "Dashboard | LMS";
          break;
        case "/courses":
          title = "Courses | LMS";
          break;
        case "/my-courses":
          title = "My Courses | LMS";
          break;
        case "/my-profile":
          title = "My Profile | LMS";
          break;
        case "/certificate-list":
          title = "My Certificates | LMS";
          break;
        case "/notifications":
          title = "My Notifications | LMS";
          break;
        case "/surveys":
          title = "Surveys | LMS";
          break;
        case "/support":
          title = "New Support Ticket | LMS";
          break;
        case "/support-ticket":
          title = "Support Ticket | LMS";
          break;
        default:
          title = "LMS";
      }
    }
    document.title = title;
  }, [location]);

  const styles = {
    firefoxBrowser: (isFirefox) => ({
      height:
        isFirefox &&
        (VALID_PATHS.has(currentPath) || HANDLED_PATHS.has(currentPath))
          ? "100vh"
          : "",
      paddingBottom:
        isFirefox && VALID_PATHS.has(currentPath) ? "80px" : "0px",
    }),
  };
  const classes = useStyles(styles)();
  const containerClassName = `container ${openSidebar ? "open-drawer" : ""} ${isFirefox ? classes.firefoxBrowser : ""}`;
  const handleContainerClick = windowScreenWidth <= screenWidth ? closeDrawer : undefined;

  return (
    <Box
      style={{ height: "-webkit-fill-available" }}
      className={containerClassName}
      onClick={handleContainerClick}
    >
      {children}
    </Box>
  );
};

Navigation.propTypes = {
  children: PropTypes.node,
  openSidebar: PropTypes.bool,
  windowScreenWidth: PropTypes.number,
  screenWidth: PropTypes.number,
  closeDrawer: PropTypes.func,
};

export default Navigation;
